var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',[_c('v-btn',{staticStyle:{"color":"white"},attrs:{"color":"#216AA9"},on:{"click":_vm.exportExcel}},[_vm._v("ดาวน์โหลด Excel")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }